import { createSlice } from '@reduxjs/toolkit';
import { readToken } from 'Utils/Helpers/Token';

const userSlice = createSlice({
    name: 'user',
    initialState : {
        isLogin: readToken() !== undefined,
        name: '',
        mobile: '',
        clinic: '',
        access: null,
    },
    reducers : {
        changeToLogin: (state) => {
            state.isLogin = true;
        },
        changeToLogout: (state) => {
            state.isLogin = false;
        },
        setUserData: (state, action) => {
            state.name = action.payload.name;
            state.mobile = action.payload.mobile;
            state.clinic = action.payload.clinic_name;
            document.title = 'آرما کلینیک | ' + action.payload.clinic_name;
        },
        setUserAccess: (state, action) => {
            state.access = action.payload;
        },
    }
})

export const { 
    changeToLogin,
    changeToLogout,
    setUserData,
    setUserAccess,
 } = userSlice.actions;

export default userSlice.reducer;